class MobileSlideMenu extends HTMLElement {
  constructor(type) {
    super();
    this.type = type || 'drawer';
    this.trigger = document.querySelector(`[data-${this.type}-toggle]`) || this.querySelector(`[data-${this.type}-trigger]`);
    this.close = this.querySelector(`[data-${this.type}-close]`) || this.trigger;
    this.content = this.querySelector(`[data-${this.type}]`);

    this.handleScroll = this.handleScroll.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.trigger.addEventListener('click', (e) => this.toggleMenu(e));
    if (blockCustomerActions) return;

    if (this.close && this.close !== this.trigger) this.close.addEventListener('click', () => this.toggleMenu());
  }

  addWindowEvents() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('click', this.handleOutsideClick);
  }

  removeWindowEvents() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('click', this.handleOutsideClick);
  }

  handleScroll(e) {
    if (e.target !== this.content && this.content.classList.contains('is-open')) this.toggleMenu();
  }

  handleOutsideClick(e) {
    if (e.target === this.trigger) return;

    const shouldClose = (e.target !== this && !this.contains(e.target) && e.target !== this.trigger) || e.target === this.close;

    if (shouldClose && this.content.classList.contains('is-open')) this.toggleMenu();
  }

  toggleMenu(e) {
    if (blockCustomerActions) {
      window.theme.internalCustomerRidirect(true);
      return;
    }

    const isOpen = this.content.classList.contains('is-open');

    if (isOpen) {
      this.content.addEventListener('transitionend', () => this.content.classList.remove('is-closing'), { once: true });
      this.content.classList.replace('is-open', 'is-closing');
      this.setAttribute('aria-hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.removeWindowEvents();
    } else {
      this.content.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.addWindowEvents();
    }
  }
}

if (!customElements.get('mobile-slide-menu')) customElements.define('mobile-slide-menu', MobileSlideMenu);

class CollapsibleElement extends MobileSlideMenu {
  constructor() {
    super('collapsible');
  }

  connectedCallback() {
    super.connectedCallback();
    this.content.addEventListener('click', (e) => {
      if (e.target.tagName === "A" && e.target.getAttribute("href") !== "#") {
        e.stopPropagation();
        GTM.trackMenuClick(
          e.target.textContent.trim(),
          this.trigger.textContent.trim(),
          this.parentElement?.closest(".collapse__menu-item")?.trigger?.textContent.trim() || ''
        );
      }
    });
  }

  toggleMenu() {
    super.toggleMenu();

    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';

    if (this.closest(".collapse__menu-item") && !isOpen) return;

    const scrollableContent = this.closest('[data-drawer-content]'),
      heightLimit = this.offsetTop >= scrollableContent.clientHeight * 0.3,
      scrollOn = scrollableContent.scrollTop > 0,
      scrollTo = isOpen && (heightLimit || scrollOn) ? this.offsetTop : 0;

    if (scrollTo > 0) {
      this.scrollIntoView();
    } else {
      scrollableContent.scrollTo({ top: scrollTo, behavior: 'smooth' });
      this.closest('[data-scroll-lock-scrollable]').scrollTo({ top: scrollTo, behavior: 'smooth' }); //Ensures the element is scrolled also on iOS devices
    }
  }
}

if (!customElements.get('collapsible-element')) customElements.define('collapsible-element', CollapsibleElement);